<template>
  <div class="project-weather">
    <weatherSafety setNum="2"></weatherSafety>
    <!-- <iframe
      scrolling="no"
      src="https://tianqiapi.com/api.php?style=tl&skin=pitaya"
      frameborder="0"
      width="90%"
      height="150"
      style="background:#FFFFFF;color:#FFFFFF;margin:0 20px;text-align:center;"
      allowtransparency="true"
    ></iframe>  -->
  </div>
</template>
<script>
import weatherSafety from '../common/weatherSafety'
export default {
  name: "weatherModule",
  components: {
    weatherSafety
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.project-weather{
  margin: 0 20px;
}
</style>